import * as React from 'react';

function SvgTriangleLeft(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11 15l7.059 6V9L11 15z" fill="#414B56" />
    </svg>
  );
}

export default SvgTriangleLeft;
